export default __webpack_public_path__ + "icon4bde248.png";